<template>
  <div>
    <header class="main-header">
      <!-- Logo -->
      <a class="logo">
        <span class="logo-mini"> 基站 </span>
        <span class="logo-lg"> 智能基站管理系统 </span>
      </a>
      <nav class="navbar navbar-static-top">
        <a
          href="#"
          class="sidebar-toggle"
          data-toggle="push-menu"
          role="button"
        >
          <span class="sr-only">Toggle navigation</span>
        </a>

        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <li class="dropdown notifications-menu">
              <ul class="dropdown-menu">
                <li class="header">You have 10 notifications</li>
                <li>
                  <ul class="menu">
                    <li>
                      <a href="#">
                        <i class="fa fa-users text-aqua"></i> 5 new members
                        joined today
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-warning text-yellow"></i> Very long
                        description here that may not fit into the page and may
                        cause design problems
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-users text-red"></i> 5 new members
                        joined
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-shopping-cart text-green"></i> 25 sales
                        made
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-user text-red"></i> You changed your
                        username
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="footer">
                  <a href="#">View all</a>
                </li>
              </ul>
            </li>
            <!-- Tasks: style can be found in dropdown.less -->
            <li class="dropdown tasks-menu">
              <ul class="dropdown-menu">
                <li class="header">You have 9 tasks</li>
                <li>
                  <ul class="menu">
                    <li>
                      <a href="#">
                        <h3>
                          Design some buttons
                          <small class="pull-right">20%</small>
                        </h3>
                        <div class="progress xs">
                          <div
                            class="progress-bar progress-bar-aqua"
                            style="width: 20%"
                            role="progressbar"
                            aria-valuenow="20"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <span class="sr-only">20% Complete</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <!-- end task item -->
                    <li>
                      <a href="#">
                        <h3>
                          Create a nice theme
                          <small class="pull-right">40%</small>
                        </h3>
                        <div class="progress xs">
                          <div
                            class="progress-bar progress-bar-green"
                            style="width: 40%"
                            role="progressbar"
                            aria-valuenow="20"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <span class="sr-only">40% Complete</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <h3>
                          Some task I need to do
                          <small class="pull-right">60%</small>
                        </h3>
                        <div class="progress xs">
                          <div
                            class="progress-bar progress-bar-red"
                            style="width: 60%"
                            role="progressbar"
                            aria-valuenow="20"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <span class="sr-only">60% Complete</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <h3>
                          Make beautiful transitions
                          <small class="pull-right">80%</small>
                        </h3>
                        <div class="progress xs">
                          <div
                            class="progress-bar progress-bar-yellow"
                            style="width: 80%"
                            role="progressbar"
                            aria-valuenow="20"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <span class="sr-only">80% Complete</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <!-- end task item -->
                  </ul>
                </li>
                <li class="footer">
                  <a href="#">View all tasks</a>
                </li>
              </ul>
            </li>
            <!-- User Account: style can be found in dropdown.less -->
            <li class="dropdown user user-menu">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <img
                  :src="user_info.avatar_url"
                  class="user-image"
                  alt="User Image"
                />
                <span class="hidden-xs">{{ user_info.username }}</span>
              </a>
              <ul class="dropdown-menu">
                <!-- User image -->
                <li class="user-header">
                  <img
                    :src="user_info.avatar_url"
                    class="img-circle"
                    alt="User Image"
                  />

                  <p>
                    {{ user_info.username }}
                    <small style="margin-top: 10px">{{ companyname }}</small>
                  </p>
                </li>
                <li class="user-footer">
                  <div class="pull-right">
                    <a
                      href="#"
                      class="btn btn-default btn-flat"
                      @click="signOut"
                      >退出</a
                    >
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <aside class="main-sidebar">
      <section class="sidebar">
        <div class="user-panel">
          <div class="pull-left image">
            <img
              :src="user_info.avatar_url"
              class="img-circle"
              alt="User Image"
            />
          </div>
          <div class="pull-left info">
            <p>{{ user_info.username }}</p>
            <a> <i class="fa fa-circle text-success"></i> Online </a>
          </div>
        </div>
        <ul class="sidebar-menu" data-widget="tree">
          <li class="header"></li>
          <li>
            <router-link to="/homepage">
              <i class="fa fa-line-chart"></i>
              <span>首页</span>
            </router-link>
          </li>
          <li class="treeview">
            <a>
              <i class="fa fa-folder-open" />
              <span>基站管理</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right" />
              </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link to="/stationOnMap">
                  <i class="fa fa-map"></i>基站图层
                </router-link>
              </li>
              <li>
                <router-link to="/stationManager">
                  <i class="fa fa-pencil-square"></i>基站管理
                </router-link>
              </li>
              <li>
                <router-link to="/layermanager">
                  <i class="fa fa-cog"></i>片区管理
                </router-link>
              </li>
            </ul>
          </li>

          <li class="treeview" v-show="false">
            <a>
              <i class="fa fa-folder-open" />
              <span>发起审批</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right" />
              </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link to="/apply_leave">
                  <i class="fa fa-map"></i>请假申请
                </router-link>
              </li>
              <li>
                <router-link to="/apply_stamp_use">
                  <i class="fa fa-map"></i>用章申请
                </router-link>
              </li>
              <li>
                <router-link to="/apply_reimbursement">
                  <i class="fa fa-map"></i>报销申请
                </router-link>
              </li>
              <li>
                <router-link to="/apply_procurement">
                  <i class="fa fa-map"></i>采购申请
                </router-link>
              </li>
              <li>
                <router-link to="/apply_station_amend">
                  <i class="fa fa-map"></i>基站信息
                </router-link>
              </li>
              <li>
                <router-link to="/apply_station_set_up">
                  <i class="fa fa-map"></i>立项申请
                </router-link>
              </li>
              <li>
                <router-link to="/apply_pay_task_set_up">
                  <i class="fa fa-map"></i>结费任务
                </router-link>
              </li>
              <li>
                <router-link to="/apply_pay_task_payment">
                  <i class="fa fa-map"></i>收付申请
                </router-link>
              </li>
              <li>
                <router-link to="/apply_pay_e_bills">
                  <i class="fa fa-map"></i>付电费申请
                </router-link>
              </li>
              <li>
                <router-link to="/apply_collect_e_bills">
                  <i class="fa fa-map"></i>收电费申请
                </router-link>
              </li>
            </ul>
          </li>

          <li v-show="false">
            <router-link to="/approval_center">
              <i class="fa fa-building"></i>
              <span>审批中心</span>
            </router-link>
          </li>
          <li v-show="false">
            <router-link to="/approval_record">
              <i class="fa fa-building"></i>
              <span>审批历史</span>
            </router-link>
          </li>
          <li v-show="false">
            <router-link to="/my_apply_list">
              <i class="fa fa-building"></i>
              <span>我的申请</span>
            </router-link>
          </li>
          <li>
            <router-link to="/workflow_list">
              <i class="fa fa-building"></i>
              <span>流程编排</span>
            </router-link>
          </li>
          <li>
            <router-link to="/ammeterlist">
              <i class="fa fa-building"></i>
              <span>电表管理</span>
            </router-link>
          </li>
          <li v-show="false">
            <router-link to="/paytasklist">
              <i class="fa fa-building"></i>
              <span>结费任务</span>
            </router-link>
          </li>
          <li>
            <router-link to="/stationImport">
              <i class="fa fa-sign-in"></i>
              <span>基站导入</span>
            </router-link>
          </li>
          <li>
            <router-link to="/batchManagement">
              <i class="fa fa-database"></i>
              <span>批量管理</span>
            </router-link>
          </li>
          <li>
            <router-link to="/stationWarning">
              <i class="fa fa-warning"></i>
              <span>基站预警</span>
            </router-link>
          </li>
          <li>
            <router-link to="/stationAlarm">
              <i class="fa fa-frown-o"></i>
              <span>基站告警</span>
            </router-link>
          </li>
          <li>
            <router-link to="/ammetertasklist">
              <i class="fa fa-flag"></i>
              <span>查表任务</span>
            </router-link>
          </li>
          <li>
            <router-link to="/checktask">
              <i class="fa fa-list-ol"></i>
              <span>巡检任务</span>
            </router-link>
          </li>
          <li>
            <router-link to="/repairtask">
              <i class="fa fa-hourglass"></i>
              <span>抢修任务</span>
            </router-link>
          </li>
          <li>
            <router-link to="/informationAudit">
              <i class="fa fa-gavel"></i>
              <span>信息审核</span>
            </router-link>
          </li>
          <li>
            <router-link to="/">
              <i class="fa fa-drivers-license"></i>
              <span>切换公司</span>
            </router-link>
          </li>
          <li>
            <router-link to="/employeeAudit">
              <i class="fa fa-user-circle-o"></i>
              <span>员工审核</span>
            </router-link>
          </li>
        </ul>
      </section>
      <!-- /.sidebar -->
    </aside>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      user_info: {},
      companyname: "",
    };
  },
  mounted: function () {
    var self = this;
    self.global.axiosGet(
      self,
      "wechat/user_info/",
      function (res) {
        console.log("user_info", res);
        self.user_info = res.current_user;
        if (!res.current_user) {
          self.signOut();
        }
      },
      function (res) {
        self.signOut();
      }
    );
    var companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    console.log("companyInfo", companyInfo);
    if (companyInfo == null) {
      this.$router.push({
        path: "/",
      });
      return;
    }
    self.companyname = companyInfo.name;
  },
  methods: {
    // 退出登录
    signOut: function () {
      window.localStorage.clear();
      this.$router.push({
        path: "/login",
      });
    },
  },
};
</script>
<style scoped>
.main-sidebar {
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}
.main-sidebar::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
</style>


// WEBPACK FOOTER //
// src/components/header/header.vue